import React__default from 'react';
import createSvgIcon from '../utils/createSvgIcon.js';
import '../SvgIcon-0b8a779c.js';
import 'classnames';

var ThreeSixty = createSvgIcon(React__default.createElement("path", { d: "M21 21L21 3C20.3058 3.29752 19.6411 3.56554 19 3.80405C13.8182 5.73198 10.1818 5.73198 5 3.80405C4.35894 3.56554 3.69422 3.29752 3 3L3 21C3.69422 20.7025 4.35894 20.4345 5 20.1959C10.1818 18.268 13.8182 18.268 19 20.1959C19.6411 20.4345 20.3058 20.7025 21 21ZM19 18.0699L19 5.93007C16.5417 6.78722 14.2974 7.25 12 7.25C9.7026 7.25 7.4583 6.78722 5 5.93007L5 18.0699C7.4583 17.2128 9.7026 16.75 12 16.75C14.2974 16.75 16.5417 17.2128 19 18.0699Z", fillRule: "evenodd" }), 'ThreeSixty');

export { ThreeSixty };
